import { Button } from '@trackman/web-shared-components';
import { ReactComponent as Plus } from 'images/icons/Plus.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { useOrganizationStore } from 'stores/Organization/OrganizationStore';

export const AddNewClassButton = ({ intent }: { intent: 'primary' | 'secondary' }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const location = useLocation();
  const setIsAddNewClassModalOpen = useOrganizationStore((state) => state.setIsAddNewClassModalOpen);

  const handleClick = () => {
    setIsAddNewClassModalOpen(true);
    if (location.pathname !== '/Organization/Classes') {
      navigate('/Organization/Classes');
    }
  };

  return <Button startIcon={<Plus />} label={t('AddANewClass', { ns: 'organizationPage' })} onClick={handleClick} intent={intent} />;
};
